import { render } from "./VocAddManyDrawer.vue?vue&type=template&id=52d511f8&scoped=true"
import script from "./VocAddManyDrawer.vue?vue&type=script&lang=js"
export * from "./VocAddManyDrawer.vue?vue&type=script&lang=js"

import "./VocAddManyDrawer.vue?vue&type=style&index=0&id=52d511f8&scoped=true&lang=css"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d511f8"]])

export default __exports__